<template>
  <div v-if="milestonesMeta" id="milestone-tabs" class="relative-position swap-height">
    <MilestonesNavigation
      :loading="loading"
      :selected-milestone-marker="selectedMilestoneMarker"
      @select-milestone="selectMilestone($event)"
      @change-period="changePeriod($event)"
    />

    <MilestoneEventContent
      v-if="selectedMilestoneMeta"
      key="milestone_event_content"
      :loading="loading"
      :period-id="selectedPeriodId"
      :meta="selectedMilestoneMeta"
    />

    <Grid v-else class="relative-position" style="min-height: 200px">
      <QInnerLoading :showing="true">
        <QSpinnerHourglass size="3.5rem" color="primary-1" />
      </QInnerLoading>
    </Grid>
  </div>

  <Grid v-else class="relative-position" style="min-height: 200px">
    <QInnerLoading :showing="true">
      <QSpinnerHourglass size="3.5rem" color="primary-1" />
    </QInnerLoading>
  </Grid>
</template>

<script>
import MILESTONES_MIXIN from '@/mixins/milestones.mixin'
// Libraries
import { findIndex, get } from 'lodash'
import { mapState } from 'vuex'
// Components
import MilestoneEventContent from './MilestoneEventContent'
import MilestonesNavigation from './MilestonesNavigation'

export default {
  components: {
    MilestoneEventContent,
    MilestonesNavigation
  },

  mixins: [MILESTONES_MIXIN],

  data() {
    return {
      selectedMilestoneMeta: null,
      selectedMilestoneMarker: 0,
      loading: true
    }
  },

  computed: {
    ...mapState('subscriptions/subscriptionPeriods', {
      milestonesMeta: state => state.milestonesMeta
    }),

    selectedPeriodId: {
      get() {
        return this.$store.state['subscription-show'].periodId
      },

      set(newVal) {
        this.$store.commit('subscription-show/setPeriodId', newVal)
      }
    }
  },

  watch: {
    selectedPeriodId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.loading = true
          this.$store.commit('subscriptions/subscriptionPeriods/resetMilestones')
          this.selectedMilestoneMeta = null
          this.refreshMilestoneData(newVal)
        }
      }
    }
  },

  created() {
    this.$root.$on('refresh-milestones-data', e => {
      this.loading = true
      this.selectedPeriodId = e.periodId
      this.getMilestonesData(e.periodId).then(result => {
        this.loading = false
        let milestonesWithStatus = get(result, 'milestones_with_status', [])
        let index = e.milestone
          ? findIndex(milestonesWithStatus, x => x.system_name === e.milestone)
          : this.getLastCompletedMarker(milestonesWithStatus)
        this.selectMilestone({
          event: milestonesWithStatus[index],
          index
        })
      })
    })
  },

  beforeDestroy() {
    this.$root.$off('refresh-milestones-data')
  },

  methods: {
    refreshMilestoneData(periodId) {
      this.getMilestonesData(periodId).then(result => {
        let milestonesWithStatus = get(result, 'milestones_with_status', [])
        if (milestonesWithStatus.length) {
          this.selectedMilestoneMarker = this.getLastCompletedMarker(milestonesWithStatus)
          this.selectedMilestoneMeta = milestonesWithStatus[this.selectedMilestoneMarker]
          this.loading = false
        }
      })
    },

    selectMilestone(payload) {
      this.selectedMilestoneMarker = payload.index
      this.selectedMilestoneMeta = null
      setTimeout(() => {
        this.selectedMilestoneMeta = payload.event
      }, 300)
    },

    changePeriod(event) {
      this.loading = true
      if (!event) return
      this.selectedPeriodId = event
    },

    getMilestonesData(id) {
      this.loading = true
      return this.$store.dispatch('subscriptions/subscriptionPeriods/getMilestones', {
        id
      })
    }
  }
}
</script>
